import classes from './TempScheduleDialog.module.css';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';

export const TempScheduleDialog = ({showTempSch, setShowTempSch, length, setLength, PinState, HandlePinClick, TempSchedule, showCancelTempSch, setShowCancelTempSch, CancelTempSchedule}) => {
    console.log('time value', length)
    return (
        <>
            <Dialog
                header="For how long?"
                visible={showTempSch}
                style={{ width: '30vw' }}
                onHide={() => setShowTempSch(false)}
            >
                <div className={classes.container}>
                    <h4>Timers sync with the clock so they may begin up to 60 seconds below your chosen time.</h4>
                    <InputNumber
                        value={length?.hours ?? 0}
                        onValueChange={(e) => setLength({ ...length, hours: e.value })}
                        showButtons
                        min={0}
                        max={23}
                        suffix=" hrs"
                        incrementButtonClassName={classes.spinnerBtn}
                        decrementButtonClassName={classes.spinnerBtn}
                    />
                    <InputNumber
                        value={length?.minutes ?? 0}
                        onValueChange={(e) => setLength({ ...length, minutes: e.value })}
                        showButtons
                        min={5}
                        max={59}
                        suffix=" min"
                        incrementButtonClassName={classes.spinnerBtn}
                        decrementButtonClassName={classes.spinnerBtn}
                    />
                    <Button
                        type='button'
                        label={`Temporarily ${PinState ? 'Arm' : 'Disarm'}`}
                        severity='secondary'
                        onClick={() => {
                            HandlePinClick();
                            TempSchedule();
                            setShowTempSch(false);
                        }}
                    />
                </div>

            </Dialog>

            <Dialog
                header={`Cancel Temporary ${PinState ? 'Disarm' : 'Arm'}? `}
                visible={showCancelTempSch}
                style={{ width: '30vw'}}
                onHide={() => setShowCancelTempSch(false)}
            >
                <div className={classes.container}>
                    <h4>This will revert the status, are you sure you want to cancel this?</h4>
                    <div className={classes.btnRow}>
                        <Button type='button' label='No' severity='secondary' onClick={() => setShowCancelTempSch(false)} />
                        <Button type='button' label='Yes' severity='danger' onClick={() => CancelTempSchedule()} />
                    </div>
                </div>
            </Dialog>
        </>
    )
}